module.exports = __webpack_public_path__ + "img/[便便].e33f7c70.svg";